import { AntTag } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { LogisticsKRTrip, TripStatus } from 'views/pages/LogisticsKR/types'

export const TripStatusTag: FC<{ status: LogisticsKRTrip['status'] }> = ({ status }) => {
  const { t } = useTranslation('logisticsKR')
  return (
    <AntTag color={status === TripStatus.security_rejected ? 'red' : 'white'}>
      {t(`logisticsKR:tripStatuses.${status}`)}
    </AntTag>
  )
}
